import { computed, unref } from '@nuxtjs/composition-api'
import { MaybeRef } from '@vueuse/core'

import PricedCar from '@/classes/PricedCar'
import Car from '@/classes/Car'

import useI18n from '@/composables/use-i18n'

export type Description = {
  name: string,
  icon?: string,
  status?: 'default' | 'light' | 'strong'
}

export default function (
  car: MaybeRef<PricedCar | Car | null>
) {
  const i18n = useI18n()

  const images = computed(() => {
    const carValue = unref(car)
    if (!carValue) return
    return carValue.images
  })

  const descriptions = computed(() => {
    const carValue = unref(car)
    if (!carValue) return []

    const { age, seats, transmission, equipments, isDomestic } = carValue
    const list: Description[] = []

    if (age != null) {
      list.push({
        name: i18n.tc('car.age', age, [age]),
        icon: 'icon-car-time',
        status: 'default',
      })
    }

    if (seats != null) {
      list.push({
        name: i18n.tc('car.seatCount', seats, [seats]),
        icon: 'icon-car-people',
        status: 'light',
      })
    }

    if (transmission) {
      list.push({
        name: transmission?.name ?? '',
        icon: 'icon-gears',
        status: 'light',
      })
    }

    if (isDomestic != null) {
      list.push({
        name: (isDomestic) ? i18n.tc('car.domesticCar') : i18n.tc('car.importedCar'),
        icon: 'icon-flag',
        status: 'light',
      })
    }

    if (equipments.find(({ id }) => id === 2)) {
      list.push({
        name: i18n.t('car.equipment.gps') as string,
        icon: 'icon-gps',
        status: 'light',
      })
    }

    if (equipments.find(({ id }) => id === 1)) {
      list.push({
        name: i18n.t('car.equipment.dashCam') as string,
        icon: 'icon-camera',
        status: 'light',
      })
    }

    return list
  })

  const insurances = computed(() => {
    const carValue = unref(car)
    if (!carValue) return

    const { insurances } = carValue
    type Insurance = { [id: number]: { url: string } }

    return insurances.map(({ id, name: content }) => {
      const item = ({
        // 1~4 車體險說明連結
        1: { url: 'https://pse.im/HS3ZL' },
        2: { url: 'https://pse.im/HS3ZL' },
        3: { url: 'https://pse.im/HS3ZL' },
        4: { url: 'https://pse.im/HS3ZL' },
        // 8 強制險說明連結
        8: { url: 'https://pse.im/GEHH5' },
      } as Insurance)[id]

      return {
        content,
        link: item?.url,
      }
    })
  })

  const equipments = computed(() => {
    const carValue = unref(car)
    if (!carValue) return
    const { equipments } = carValue
    return equipments.map(({ name }) => name)
  })

  return {
    images,
    descriptions,
    insurances,
    equipments,
  }
}
